import { Box, Grid, Skeleton } from "@mui/material";
import Title from "../components/global/Title";
import WrapperSection from "../components/global/WrapperSection";
import Header from "../components/global/headers/Header";
import { useEffect, useState } from "react";
import AnimatedSection from "../components/global/AnimatedSection";
import { useProducts } from "../hooks/products/useProducts";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { motion } from 'framer-motion';
import ItemCat from "../components/productTractor/ItemCat";
import { useProductsCategory } from "../hooks/products/useProductsCategory";

const Category = () => {
    // const {} =
    const containerVariants = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.15, // وقت التأخير بين العناصر
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 50, scale: 0.8 },
        show: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                type: "spring",
                stiffness: 100,
                damping: 10,
            },
        },
    };

    const location = useLocation();
    const { catSlug } = location.state || {};
    const { slug } = useParams()
    const [page, setPage] = useState(1);
    const [selectCat, setSelectCat] = useState(catSlug || null);
    const { productsCategory, isLoading: isLoadingCategory } = useProductsCategory(slug)
    useEffect(() => {
        setSelectCat(catSlug || null);
    }, [catSlug]);
    const navigate = useNavigate()
    const {
        products,
        isLoading,
        isFetching: isFetchingProducts,
    } = useProducts(selectCat, page);
    useEffect(() => {
        if (productsCategory?.data?.slug && slug !== productsCategory?.data?.slug) {
            navigate(`/categories/${productsCategory?.data.slug}`, { replace: true });
        }
    }, [productsCategory?.data, slug, navigate]);
    useEffect(() => {
        setPage(1);
    }, [selectCat]);

    return (
        <>
            <Box sx={{ overflow: "hidden" }}>
                <Header page_name={`${products?.pageName} - ${productsCategory?.data?.name}`} />
                <WrapperSection>
                    <Box>
                        <Title color="primary" title={productsCategory?.data?.name} />
                        <Title color="primary.bold" title={products?.subTitle} variant="h4" />
                        {/* Product grid */}
                        {isLoading || isFetchingProducts || isLoadingCategory ? (
                            <Box sx={{ display: "flex", gap: 2 }}>
                                {Array.from(new Array(5)).map((_, index) => (
                                    <Skeleton
                                        animation="wave"
                                        key={index}
                                        height={250}
                                        width={250}
                                    />
                                ))}
                            </Box>
                        ) : (
                            <Grid
                                container
                                spacing={2}
                                justifyContent={"space-evenly"}
                                component={motion.div}
                                variants={containerVariants}
                                initial="hidden"
                                animate="show"
                            >
                                {productsCategory?.data?.children?.map((product, i) => (
                                    <Grid
                                        item
                                        xl={3}
                                        md={3}
                                        xs={12}
                                        key={product.id}
                                        component={motion.div}
                                        variants={itemVariants}>
                                        <AnimatedSection index={i}>
                                            <ItemCat product={product} />
                                        </AnimatedSection>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Box>
                </WrapperSection>
            </Box>
        </>
    );
};

export default Category;